const ACTION_PREFIX = '@@app/typing'
const makeConstant = (constant) => `${ACTION_PREFIX}/${constant}`

export const TYPING = makeConstant('TYPING')
export const TYPING_FINISHED = makeConstant('TYPING_FINISHED')

export const USER_TYPING = makeConstant('USER_TYPING')
export const USER_TYPING_FINISHED = makeConstant('USER_TYPING_FINISHED')



// WEBPACK FOOTER //
// ./src/scripts/app/modules/typing/constants.js